import React from "react";
import { Box, Card, Grid } from "@mantine/core";
import { StereoAcuityData } from "types/testTypes";
import { useTranslation } from "react-i18next";
import { ScatterChart } from "@mantine/charts";
import theme from "theme";

interface StereoAcuityTimeChartProps {
  stereoAcuityDatas: StereoAcuityData[] | null;
}
const StereoAcuityTimeChart: React.FC<StereoAcuityTimeChartProps> = ({ stereoAcuityDatas }) => {
  const { t } = useTranslation();
  const [data, setData] = React.useState<
    { color: string; name: string; data: { time: number; [key: string]: number }[] }[]
  >([]);

  React.useEffect(() => {
    const correctResponses: { time: number; [key: string]: number }[] = [];
    const incorrectResponses: { time: number; [key: string]: number }[] = [];
    if (stereoAcuityDatas) {
      stereoAcuityDatas.forEach((item) => {
        if (item.isTrue) {
          correctResponses.push({
            time: Number(item.responseTime.toFixed(2)),
            [t("extraTests.stereoAcuity.angleArcsec")]: Number(item.currentAngleArcsec.toFixed(2)),
          });
        } else {
          incorrectResponses.push({
            time: Number(item.responseTime.toFixed(2)),
            [t("extraTests.stereoAcuity.angleArcsec")]: Number(item.currentAngleArcsec.toFixed(2)),
          });
        }
      });
      const formattedData = [
        {
          color: "blue",
          name: t("common.correctResponse"),
          data: correctResponses,
        },
        {
          color: "red",
          name: t("common.incorrectResponse"),
          data: incorrectResponses,
        },
      ];

      setData(formattedData);
    }
  }, [stereoAcuityDatas]);

  return (
    <Box w="100%" h="100%">
      <Grid>
        <Grid.Col>
          <Card withBorder>
            <ScatterChart
              h={theme.spacing.longChart}
              data={data}
              dataKey={{ x: "time", y: t("extraTests.stereoAcuity.angleArcsec") }}
              xAxisLabel="s"
              yAxisLabel={t("extraTests.stereoAcuity.angleArcsec")}
              legendProps={{ verticalAlign: "bottom", height: 20, align: "center" }}
              xAxisProps={{ type: "number", domain: [0, "dataMax + 1"] }}
              withLegend
            />
          </Card>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default StereoAcuityTimeChart;
